import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { LearningRecordPodcast, UpdatePodcastSessionRequest } from "src/types/coaching/learners";
import React, { useEffect, useMemo, useState } from "react";

import _ from 'lodash';
import cx from 'classnames';

import { useDispatch } from "react-redux";
import {
  enrollPodcast,
  fetchLearningRecordPodcast,
  fetchTranscriptsForLearningPodcast,
  startPodcast,
  updatePodcastSession
} from "src/redux/actions/coaching/learners";

import userRoleService from "src/services/userRoles.service";
import PermissionDenined from "src/components/permissionDenied";
import { CourseNotFound } from "src/pages/coaching/components/notFound";

import styles from "./view.module.scss";
import { PodcastContext, PodcastContextProps } from "src/pages/coaching/components/podcast/context";
import { LoadingPodcastPage, PodcastSummaryComponent } from "src/pages/coaching/components/podcast";
import { PodcastTranscripts } from "src/types/coaching/podcast";
import { fetchPublicPodcast } from "src/redux/actions/coaching/podcast";

interface EnrollPodcastState {
  podcast: LearningRecordPodcast | null;
}

export const ViewExplorePodcastPage: React.FC<object> = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const id = params.id;

  const podcast = useSelector((state: any) =>
    _.get(state.coaching, `podcasts.podcast[${id}].item`),
  );

  const loading = useSelector((state: any) =>
    _.get(state.coaching, `podcasts.podcast[${id}].loading`),
  );

  const podcastErrorCode = useSelector((state: any) => {
    return _.get(state.coaching, `podcasts.podcast[${id}].error.errors[0].code`);
  });

  const podcastTranscripts = useSelector((state: any) =>
    _.get(state.coaching, `podcasts.podcast[${id}].transcripts.item`) as PodcastTranscripts,
  );

  const enrollingPodcast = useSelector((state: any) => {
    const enrolling = _.get(state.coaching, `podcasts.podcast[${id}].enroll.enrolling`);
    return enrolling;
  });

  const podcastEnrolled = useSelector((state: any) => {
    return _.get(state.coaching, `podcasts.podcast[${id}].enroll.enrolled`);
  });

  const podcastEnrolledId = useSelector((state: any) => {
    return _.get(state.coaching, `podcasts.podcast[${id}].enroll.id`);
  });

  const [podcastContext, setPodcastContext] = React.useState<PodcastContextProps>({
    id: id,
  });

  const [publicCourse, setPublicCourse] = useState<EnrollPodcastState>({
    podcast: null,
  });

  useEffect(() => {
    if (id && !podcast) {
      dispatch(fetchPublicPodcast({ id: id }));
    }

    setPodcastContext((prev) => {
      return {
        ...prev,
        id: id,
        onBack: handleBackClicked
      }
    });
  }, []);

  useEffect(() => {
    if (podcast) {

      //dispatch(fetchTranscriptsForLearningPodcast(podcast.id));

      setPodcastContext((prev) => {
        return {
          ...prev,
          onBack: handleBackClicked,
          startPodcast: handleStartPodcast,
          onAnalyticsChange: handleAnalyticsChange,
          enrollPodcast: handleEnrollPodcast,
        }
      });

      if (!podcast) {
        return;
      }

      setPublicCourse((prev) => {
        return {
          ...prev,
          podcast: {
            ...podcast,
            id: podcast.id!,
            podcast: podcast,
            session: null,
            status: "NOT_ENROLLED",
          },
        }
      });
    }
  }, [podcast]);

  useEffect(() => {
    if (podcastTranscripts) {
      setPodcastContext((prev) => {
        return {
          ...prev,
          transcripts: podcastTranscripts,
        }
      });
    }
  }, [podcastTranscripts]);

  useEffect(() => {
    setPodcastContext((prev) => {
      return {
        ...prev,
        enrollingPodcast: enrollingPodcast,
      }
    });
  }, [enrollingPodcast]);

  useEffect(() => {
      if (podcastEnrolledId) {
        navigate(`/coaching/podcasts/${podcastEnrolledId}?play=true`);
      }
    }, [podcastEnrolledId]);

  const handleBackClicked = () => {
    navigate(`/coaching/courses`);
  }

  const handleStartPodcast = () => {

  };

  const handleAnalyticsChange = (event: any) => {

  }

  const handleEnrollPodcast = () => {
    
    if (podcast) {
      dispatch(enrollPodcast(podcast.id));
    }
  };

  if (!userRoleService.canAccessCoaching()) {
    return <PermissionDenined className={styles.permissionDenied} />;
  }

  if (podcastErrorCode === 10007) {
    return <CourseNotFound onBack={handleBackClicked} />
  }

  if ((loading && podcast?.id != id) || !podcast) {
    return (
      <LoadingPodcastPage onBack={handleBackClicked} />
    );
  }

  return (
    <PodcastContext.Provider value={podcastContext}>
      {publicCourse.podcast &&
        <PodcastSummaryComponent podcast={publicCourse.podcast} />
      }
    </PodcastContext.Provider>
  );
}